import request from '@/utils/request'

export function getImg (data) {
  return request({
    url: 'acting/img',
    method: 'GET',
    params: data
  })
}